import { render, staticRenderFns } from "./EditGreenCoffeeModal.vue?vue&type=template&id=67d3b544&scoped=true"
import script from "./EditGreenCoffeeModal.vue?vue&type=script&lang=js"
export * from "./EditGreenCoffeeModal.vue?vue&type=script&lang=js"
import style0 from "./EditGreenCoffeeModal.vue?vue&type=style&index=0&id=67d3b544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d3b544",
  null
  
)

export default component.exports